@if (customer) {
  <hawk-record-navigation
    class="app-page"
    [breadcrumbLinkList]="[{ description: 'Kunden', link: '/a/kunde' }]"
    [root]="'customer'"
    [leafDescription]="customer.name"
  >
    <div slot="toolbar" class="flex flex-row gap-2"></div>
    <div class="page-content page-frame overflow-y-auto">
      <div class="page-sheet w-full max-w-[110rem] mx-auto grid grid-cols-[1fr_3fr] gap-4">
        <div>
          <section class="bm-card bm-card-sm">
            <div class="bm-card-body">
              <h2 class="bm-card-title">Stammdaten</h2>
              <table class="bm-table bm-table-xs">
                <tbody>
                  <tr>
                    <th (click)="editName = !editName">Name</th>
                    @if (!editName) {
                      <td>{{ customer.name }}</td>
                    }
                    @if (editName) {
                      <td>
                        <hawk-shared-edit-input
                          [textValue]="customer.name"
                          (saveClicked)="saveName($any($event))"
                          (cancelClicked)="editName = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <th (click)="editLetter = !editLetter">Abkürzung</th>
                    @if (!editLetter) {
                      <td>{{ customer.letter }}</td>
                    }
                    @if (editLetter) {
                      <td>
                        <hawk-shared-edit-input
                          [upperCaseMode]="true"
                          [textValue]="customer.letter"
                          [maxInputLength]="3"
                          (saveClicked)="saveLetter($any($event))"
                          (cancelClicked)="editLetter = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <td (click)="editURL = !editURL">URL</td>
                    @if (!editURL) {
                      <td>
                        <a [href]="customer.url" target="_blank">{{ customer.url }}</a>
                      </td>
                    }
                    @if (editURL) {
                      <td>
                        <hawk-shared-edit-input
                          [textValue]="customer.url"
                          (saveClicked)="saveURL($any($event))"
                          (cancelClicked)="editURL = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <td (click)="editXMLID = !editXMLID">XML-ID</td>
                    @if (!editXMLID) {
                      <td>{{ customer.xml_id }}</td>
                    }
                    @if (editXMLID) {
                      <td>
                        <hawk-shared-edit-input
                          [textValue]="customer.xml_id"
                          (saveClicked)="saveXMLID($any($event))"
                          (cancelClicked)="editXMLID = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <td class="align-top" (click)="editAdditionalInformation = !editAdditionalInformation">Info</td>
                    @if (!editAdditionalInformation) {
                      <td class="whitespace-pre-wrap">{{ customer.additional_information }}</td>
                    }
                    @if (editAdditionalInformation) {
                      <td>
                        <hawk-shared-edit-input
                          [modus]="'textarea'"
                          [textValue]="customer.additional_information"
                          (saveClicked)="saveAdditionalInformation($any($event))"
                          (cancelClicked)="editAdditionalInformation = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <td (click)="editDeliveryNoteConfirmationMail = !editDeliveryNoteConfirmationMail">
                      LS-Bestätigungsmail
                    </td>
                    @if (!editDeliveryNoteConfirmationMail) {
                      <td>{{ customer.delivery_note_confirmation_mail }}</td>
                    }
                    @if (editDeliveryNoteConfirmationMail) {
                      <td>
                        <hawk-shared-edit-input
                          [textValue]="customer.delivery_note_confirmation_mail"
                          (saveClicked)="saveDeliveryNoteConfirmationMail($any($event))"
                          (cancelClicked)="editDeliveryNoteConfirmationMail = false"
                        />
                      </td>
                    }
                  </tr>
                  <tr>
                    <td (click)="editExpectedDeliveryNotificationMail = !editExpectedDeliveryNotificationMail">
                      Wareneingangs-Mail
                    </td>
                    @if (!editExpectedDeliveryNotificationMail) {
                      <td>{{ customer.expected_delivery_notification_mail }}</td>
                    }
                    @if (editExpectedDeliveryNotificationMail) {
                      <td>
                        <hawk-shared-edit-input
                          [textValue]="customer.expected_delivery_notification_mail"
                          (saveClicked)="saveExpectedDeliveryNotificationMail($any($event))"
                          (cancelClicked)="editExpectedDeliveryNotificationMail = false"
                        />
                      </td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          @if (customer.users.length) {
            <section class="bm-card bm-card-sm">
              <div class="bm-card-body">
                <h2 class="bm-card-title">Nutzer</h2>
                <table class="bm-table bm-table-xs">
                  <tbody>
                    @for (user of customer.users; track user) {
                      <tr>
                        <td>
                          <a [routerLink]="'/user/' + user.id">
                            <fa-icon style="margin-right: 4px" [icon]="faUser"></fa-icon>
                            {{ user.name }}
                          </a>
                        </td>
                        <td>{{ user.restriction_project?.name || "Zugriff auf alle Projekte" }}</td>
                        <td style="text-align: right">
                          <button
                            mat-raised-button
                            (click)="
                              showModal = 'user_project_access';
                              userProjectAccessUser = user;
                              selectedDefaultUserProjectId = user.restriction_project?.id || null
                            "
                          >
                            Zugriff ändern
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </section>
          }
          <section class="bm-card bm-card-sm">
            <div class="bm-card-body">
              <h2 class="bm-card-title">
                Adresse
                <a
                  class="bm-link bm-link-hover text-xs"
                  [href]="'https://maps.google.de?q=' + [customer.street, customer.zip, customer.city].join(',')"
                  target="_blank"
                >
                  Google Maps
                </a>
              </h2>
              <table class="bm-table bm-table-xs">
                <tbody>
                  <tr>
                    <td>Firma</td>
                    <td>{{ customer.company }}</td>
                  </tr>
                  <tr>
                    <td>Straße</td>
                    <td>{{ customer.street }}</td>
                  </tr>
                  <tr>
                    <td>PLZ und Ort</td>
                    <td>{{ customer.zip }} {{ customer.city }}</td>
                  </tr>
                  <tr>
                    <td>Land (Staat)</td>
                    <td>{{ (customer.country || "").toUpperCase() }}</td>
                  </tr>
                </tbody>
              </table>
              <button class="bm-btn bm-btn-block" (click)="showModal = 'address'">Adresse ändern</button>
            </div>
          </section>
          <section class="bm-card bm-card-sm">
            <div class="bm-card-body">
              <h2 class="bm-card-title">Material Rücksendungen an</h2>
              @if (!returnAddressMatchesCustomer) {
                <table class="bm-table bm-table-xs">
                  <tbody>
                    <tr>
                      <td>Firma</td>
                      <td>{{ customer.return_address_company }}</td>
                    </tr>
                    <tr>
                      <td>Name</td>
                      <td>{{ [customer.return_address_firstname, customer.return_address_lastname].join(' ').trim() }}</td>
                    </tr>
                    <tr>
                      <td>Straße</td>
                      <td>{{ customer.return_address_street }}</td>
                    </tr>
                    <tr>
                      <td>PLZ und Ort</td>
                      <td>{{ customer.return_address_zip }} {{ customer.return_address_city }}</td>
                    </tr>
                    <tr>
                      <td>Land</td>
                      <td>{{ (customer.return_address_country || '').toUpperCase() }}</td>
                    </tr>
                  </tbody>
                </table>
              }
              <div class="flex flex-row gap-2">
                <button
                  class="bm-btn flex-3"
                  [class.bm-btn-success]="returnAddressMatchesCustomer"
                  [class.no-animation]="returnAddressMatchesCustomer"
                  [class.cursor-default]="returnAddressMatchesCustomer"
                  (click)="!returnAddressMatchesCustomer && setReturnAddressFromCustomer()"
                >
                  @if (returnAddressMatchesCustomer) {
                    <fa-icon [icon]="faCheck" />
                  }
                  Kundenadresse
                </button>
                <button class="bm-btn flex-2" (click)="showModal = 'return_address'">Adresse ändern</button>
              </div>
            </div>
          </section>
          <section class="bm-card bm-card-sm">
            <div class="bm-card-body">
              <h2 class="bm-card-title">Karte</h2>
              @if (customer.lat && customer.lng) {
                <mgl-map
                  class="aspect-video"
                  [style]="'mapbox://styles/mapbox/streets-v9'"
                  [zoom]="[5]"
                  [center]="[customer.lng, customer.lat]"
                >
                  <mgl-marker [lngLat]="[customer.lng, customer.lat]">
                    <div
                      class="marker"
                      [style.borderColor]="'black'"
                      [style.backgroundColor]="'#af0000'"
                      title="{{ customer.name }}"
                    ></div>
                  </mgl-marker>
                </mgl-map>
              }
            </div>
          </section>
        </div>
        <div>
          <section>
            <div role="tablist" class="bm-tabs bm-tabs-lift w-full">
              <a role="tab" class="bm-tab" [class.bm-tab-active]="tab === 'stores'" (click)="tab = 'stores'">
                Filialen ({{ stores.length }})
              </a>
              @if (tab === "stores") {
                <div class="bm-tab-content bg-base-100 border-base-100">
                  <div class="flex flex-row items-center justify-end gap-2 py-2">
                    <button class="bm-btn bm-btn-ghost" (click)="navigateToStoreImport()">
                      <fa-icon style="margin-right: 4px" [icon]="faUpload" /> Filialen importieren
                    </button>
                    <input
                      type="text"
                      class="bm-input"
                      placeholder="Schnellfilter..."
                      (input)="storeQuickSearchChanged($event)"
                    />
                  </div>
                  <ag-grid-angular
                    class="ag-theme-quartz"
                    style="height: 530px; width: 100%"
                    [rowData]="stores"
                    [theme]="hawkTheme"
                    [defaultColDef]="defaultColDef"
                    [columnDefs]="storeColDefs"
                    [rowClassRules]="rowClassRules"
                    [pagination]="true"
                    [rowSelection]="rowSelection"
                    [paginationPageSize]="18"
                    [localeText]="locale"
                    [sideBar]="sideBarOptions"
                    [paginationPageSizeSelector]="[18, 50, 250, 1000]"
                    (gridReady)="onStoreGridReady($event)"
                  />
                </div>
              }
              <a role="tab" class="bm-tab" [class.bm-tab-active]="tab === 'projects'" (click)="tab = 'projects'">
                Projekte ({{ projects.length }})
              </a>
              @if (tab === "projects") {
                <div class="bm-tab-content bg-base-100 border-base-100">
                  <div class="flex flex-row items-center justify-end gap-2 py-2">
                    <input
                      type="text"
                      class="bm-input"
                      placeholder="Schnellfilter..."
                      (input)="projectQuickSearchChanged($event)"
                    />
                  </div>
                  <ag-grid-angular
                    class="ag-theme-quartz"
                    style="height: 530px; width: 100%"
                    [rowData]="projects"
                    [theme]="hawkTheme"
                    [defaultColDef]="defaultColDef"
                    [columnDefs]="projectColDefs"
                    [rowClassRules]="rowClassRules"
                    [pagination]="true"
                    [rowSelection]="rowSelection"
                    [paginationPageSize]="18"
                    [localeText]="locale"
                    [sideBar]="sideBarOptions"
                    [paginationPageSizeSelector]="[18, 50, 250, 1000]"
                    (gridReady)="onProjectGridReady($event)"
                  />
                </div>
              }
              <a role="tab" class="bm-tab" [class.bm-tab-active]="tab === 'articles'" (click)="tab = 'articles'">
                Material ({{ articles.length }})
              </a>
              @if (tab === "articles") {
                <div class="bm-tab-content bg-base-100 border-base-100">
                  <div class="flex flex-row items-center justify-end gap-2 py-2">
                    <input
                      type="text"
                      class="bm-input"
                      placeholder="Schnellfilter..."
                      (input)="articleQuickSearchChanged($event)"
                    />
                  </div>
                  <ag-grid-angular
                    class="ag-theme-quartz"
                    style="height: 530px; width: 100%"
                    [rowData]="articles"
                    [theme]="hawkTheme"
                    [defaultColDef]="defaultColDef"
                    [columnDefs]="articleColDefs"
                    [rowClassRules]="rowClassRules"
                    [pagination]="true"
                    [paginationPageSize]="18"
                    [localeText]="locale"
                    [sideBar]="sideBarOptions"
                    [paginationPageSizeSelector]="[18, 50, 250, 1000]"
                    (gridReady)="onArticleGridReady($event)"
                  />
                </div>
              }
            </div>
          </section>
        </div>
        <div class="col-span-2 flex flex-row items-center justify-end gap-2">
          <a class="bm-btn" [routerLink]="['/kunde']"> Zurück </a>
          <div
            [class.bm-tooltip]="!customerIsDeletable"
            data-tip="Kunden können nur gelöscht werden, wenn keine Abhängigkeiten zu Stores, Projekten, Usern und Material vorhanden sind"
          >
            <button class="bm-btn bm-btn-error" [disabled]="!customerIsDeletable" (click)="deleteCustomer()">
              <fa-icon [icon]="faTrash" />
              Löschen
            </button>
          </div>
        </div>
      </div>
    </div>
  </hawk-record-navigation>
}

@if (showModal === "address") {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold">Adresse ändern</h3>
      <hawk-shared-edit-address
        [city]="customer.city"
        [company]="customer.company"
        [country]="customer.country"
        [lat]="customer.lat"
        [lng]="customer.lng"
        [state]="customer.state"
        [street]="customer.street"
        [zip]="customer.zip"
        (onSubmitEvent)="saveAddress($event)"
        (onAbortEvent)="showModal = null"
      />
    </div>
  </dialog>
}

@if (showModal === "return_address") {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold">Rücksendeadresse ändern</h3>
      <hawk-shared-edit-address
        [editName]="true"
        [city]="customer.return_address_city"
        [company]="customer.return_address_company"
        [country]="customer.return_address_country"
        [firstname]="customer.return_address_firstname"
        [lastname]="customer.return_address_lastname"
        [street]="customer.return_address_street"
        [zip]="customer.return_address_zip"
        [lat]="0"
        [lng]="0"
        (onSubmitEvent)="saveReturnAddressFromModal($event)"
        (onAbortEvent)="showModal = null"
      />
    </div>
  </dialog>
}

@if (showModal === "user_project_access" && userProjectAccessUser) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold">Projekt auswählen</h3>

      <mat-form-field style="margin-top: 4px" class="outline-small no-subscript" appearance="outline">
        <mat-label>Projekt</mat-label>
        <mat-select [(ngModel)]="selectedDefaultUserProjectId">
          <mat-option [value]="null">-</mat-option>
          @for (project of projects; track project) {
            <mat-option [value]="project.id">{{ project.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="bm-modal-action">
        <button class="bm-btn bm-btn-ghost" (click)="showModal = null; userProjectAccessUser = null">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveUserProjectAccessUser()">Speichern</button>
      </div>
    </div>
  </dialog>
}
